export enum SearchMode {
  "ALL" = "すべて",
  "DEPARTMENT" = "部署",
  "USER" = "ユーザ",
}
